import React from 'react';
import get from 'lodash/get';
import { useSetAtom } from 'jotai';
import { Button } from 'antd';
import { FLOW_METRICS_DISPLAY } from '@src/utils/flow/meta';
import { getPercentageMetricByKey } from '@src/utils/metrics/metricHelpers';
import { CloseOutlined, SettingOutlined } from '@ant-design/icons';
import {
  FlowContentContainer,
  GaugeSection,
  ChartSection,
  MetadataSection,
  StyledCloseBtn,
} from './styled';
import { flowToolbarPanelAtom } from '@src/atoms/panels';
import FlowMetadata from '../FlowMetadata/FlowMetadata';
import FlowChart from '../FlowChart/FlowChart';
import Gauge from '../Gauge/Gauge';
import type { FlowContentProps } from '../../types';
import { getFlowType } from '@src/components/widget-panel/widgets/flow-widget/utils';

const FlowContent = ({ data, flowMeta }: FlowContentProps) => {
  const { metrics } = flowMeta;
  const setFlowToolbarPanel = useSetAtom(flowToolbarPanelAtom);
  const successPctMetricKey = getPercentageMetricByKey({ metricKey: metrics.success });

  const handleClose = () => {
    setFlowToolbarPanel(false);
  };

  return (
    <FlowContentContainer>
      <GaugeSection>
        <Gauge
          settings={flowMeta.definition.settings}
          description={FLOW_METRICS_DISPLAY.success.description}
          value={get(data, ['totals', successPctMetricKey], 0)}
        />
      </GaugeSection>
      <ChartSection>
        <FlowChart events={flowMeta.definition.events} />
      </ChartSection>
      <MetadataSection>
        <FlowMetadata description={flowMeta.definition} />
        <Button
          color="primary"
          variant="outlined"
          icon={<SettingOutlined />}
          href={`/app/activation/workflow/${getFlowType(flowMeta)}/${flowMeta.id}`}
          target="_blank"
          style={{
            flexShrink: 0,
            whiteSpace: 'nowrap',
          }}
        >
          Configure Flow
        </Button>
        <StyledCloseBtn
          className="remove-flow-btn"
          type="text"
          icon={<CloseOutlined />}
          onClick={handleClose}
          size="small"
        />
      </MetadataSection>
    </FlowContentContainer>
  );
};

export default React.memo(FlowContent);
